declare global {
  interface Window {
    // dataLayer: unknown[]
    gtag: (...args: any[]) => void
  }
}

interface PageViewEvent {
  title: string
  location: string
  path: string
}

interface Article {
  id?: string
  name?: string
  brand?: string
  category?: string
  coupon?: string
  listName?: string
  listPosition?: number
  price?: number
  quantity?: number
  variant?: string
}

interface CartEvent {
  currency?: string
  items?: Article[]
  value?: number
}

interface BeginCheckoutEvent extends CartEvent {
  coupon?: string
}

interface CheckoutProgressEvent extends BeginCheckoutEvent {
  paymentType: string
  step: number
}

interface PurchaseEvent extends BeginCheckoutEvent {
  affiliation: string
  orderId: string
}

export default class AnalyticsService {
  constructor(private GAID: string) {}

  pageView({ title, location, path }: PageViewEvent) {
    if (!window.gtag) return
    window.gtag('event', 'page_view', {
      page_title: title,
      page_location: location, // https://example.com
      page_path: path, // /about
      send_to: this.GAID,
    })
  }

  addToCart(items: Article[]) {
    if (!window.gtag) return
    window.gtag('event', 'add_to_cart', {
      currency: 'EUR',
      items,
    })
  }

  removeFromCart(items: Article[]) {
    if (!window.gtag) return
    window.gtag('event', 'remove_to_cart', {
      currency: 'EUR',
      items,
    })
  }

  beginCheckout(items: Article[]) {
    if (!window.gtag) return
    window.gtag('event', 'begin_checkout', {
      currency: 'EUR',
      items,
    })
  }

  checkoutProgress({ coupon, items, value, paymentType, step }: CheckoutProgressEvent) {
    if (!window.gtag) return
    window.gtag('event', 'checkout_progress', {
      currency: 'EUR',
      coupon,
      checkout_option: paymentType, // tipo de pago
      checkout_step: step,
      items,
      value,
    })
  }

  purchaseComplete({ orderId, affiliation, items }: PurchaseEvent) {
    if (!window.gtag) return
    window.gtag('event', 'purchase', {
      affiliation,
      currency: 'EUR',
      tax: 3.33,
      transaction_id: orderId,
      items,
    })
  }

  viewItemList(items: Article[]) {
    if (!window.gtag) return
    window.gtag('event', 'view_item_list', {
      items,
    })
  }
}
